import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';



const loadState = (): 'GetAppointment' | 'FavoriteOrganization' | 'AppointmentList' => {
    const savedState = localStorage.getItem('publicUserMenu');
    return savedState ? savedState as 'GetAppointment' | 'FavoriteOrganization' | 'AppointmentList' : 'GetAppointment';
};

const initialState: 'GetAppointment' | 'FavoriteOrganization' | 'AppointmentList' = loadState();

const publicUserMenuSlice = createSlice({
    name: 'publicUserMenu',
    initialState,
    reducers: {
        setPublicUserMenu: (state, action: PayloadAction<'GetAppointment' | 'FavoriteOrganization' | 'AppointmentList'>) => {
            localStorage.setItem('publicUserMenu', JSON.stringify(action.payload));
            return action.payload;
        },
        removePublicUserMenu: (state) => {
            localStorage.removeItem('publicUserMenu');
            return loadState();
        },
    },
});

export const { setPublicUserMenu, removePublicUserMenu } = publicUserMenuSlice.actions;
export default publicUserMenuSlice.reducer;
export const selectPublicUserMenu = (state: RootState) => state.publicUserMenu;